<template>
    <div class="diagnosis-container f28">

      <!-- 诊断信息 -->
      <div class="diagnosis info" v-for="(item, index) in model.goodsCuringServiceRepairPointBoList" :key="index" :class="{'actived':index === active}">
        
        <div class='title' @click='toLook(index)'>
          <div :class='{nouser:!item.employStatus}'>
            <span class='dian'></span>
            <span>{{item.curingServiceName}}</span>
          </div>
          <span class='sanjiao'>

          </span>
        </div>
        <div v-for='(element,idx) in item.goodsDiagnoseBoList'>
          <div class='zhengzhuang_title'>「 症状{{Arabia_To_SimplifiedChinese(idx + 1)}} 」</div>
          <div>
            <span class="grey6">症状：</span>
            <span>{{element.symptomName}}</span>
          </div>
          <div>
            <div class="grey6">症状照片：</div>
            <div class="diagnosis-photo border-bottom">
              <div :class="['compar-photo', { 'all': imgTag }]">
                <img src="" alt=""  v-for="(ele,i) in JSON.parse(element.symptomPics)" v-lazy="formatImgUrl(ele,400,300,true)" :key="i" @click='preview(i,JSON.parse(element.symptomPics))'/>
              </div>
              <button @click='imgTag = true' :class="['down', 'f26', 'grey6']" v-if="JSON.parse(element.symptomPics).length > 2 && !imgTag">展开完整信息 <i></i></button>
              <button @click='imgTag = false' :class="['up', 'f26', 'grey6']" v-if="JSON.parse(element.symptomPics).length > 2 && imgTag">收起 <i></i></button>
            </div>
          </div>
          <div v-for='(item,index) in JSON.parse(element.speech)'>
            <span class="grey6">{{change(item)}}</span>
            <span v-html='changeText(item)'></span>
          </div>
        </div>
      </div>
      <previewer ref="previewer"></previewer>
    </div>
</template>
<script>
  export default {
    name: 'diagnosis',
    data () {
      return {
        diagnosis: [1, 2],
        collapse: [0],
        imgTag : false,
        active : ''
      }
    },
    props : {
      model : {
        type : Object,
        default : () => {}
      }
    },
    computed: {
      defaultImg () {
        return this.DEFAULT_IMG
      }
    },
    methods : {
      toLook(index){
        if(this.active === index){
          this.active = '';
        }else{
          this.active = index;
        }
      },
      formatImgUrl(url, width, height,m_fill) {
        // console.log(url)
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
      preview(index,list){
        this.$refs.previewer.show(index, list ,'症状图片')
      },
      change(item){
        if(item.explanation){
          return '症状说明：'
        }else if(item.repairation){
          return '修复方法：'
        }else if(item.prevenience){
          return '预期效果：'
        }else if(item.diagnosis){
          return '综合诊断：'
        }
      },
      Arabia_To_SimplifiedChinese(Num){
          for (var i = Num.length - 1; i >= 0; i--) {
              Num = Num.replace(",", "")//替换Num中的“,”
              Num = Num.replace(" ", "")//替换Num中的空格
          }    
          if (isNaN(Num)) { //验证输入的字符是否为数字
              //alert("请检查小写金额是否正确");
              return;
          }
          //字符处理完毕后开始转换，采用前后两部分分别转换
          var part = String(Num).split(".");
          var newchar = "";
          //小数点前进行转化
          for (var i = part[0].length - 1; i >= 0; i--) {
              if (part[0].length > 10) {
                  //alert("位数过大，无法计算");
                  return "";
              }//若数量超过拾亿单位，提示
              var tmpnewchar = ""
              var perchar = part[0].charAt(i);
              switch (perchar) {
                  case "0":  tmpnewchar = "零" + tmpnewchar;break;
                  case "1": tmpnewchar = "一" + tmpnewchar; break;
                  case "2": tmpnewchar = "二" + tmpnewchar; break;
                  case "3": tmpnewchar = "三" + tmpnewchar; break;
                  case "4": tmpnewchar = "四" + tmpnewchar; break;
                  case "5": tmpnewchar = "五" + tmpnewchar; break;
                  case "6": tmpnewchar = "六" + tmpnewchar; break;
                  case "7": tmpnewchar = "七" + tmpnewchar; break;
                  case "8": tmpnewchar = "八" + tmpnewchar; break;
                  case "9": tmpnewchar = "九" + tmpnewchar; break;
              }
              switch (part[0].length - i - 1) {
                  case 0: tmpnewchar = tmpnewchar; break;
                  case 1: if (perchar != 0) tmpnewchar = tmpnewchar + "十"; break;
                  case 2: if (perchar != 0) tmpnewchar = tmpnewchar + "百"; break;
                  case 3: if (perchar != 0) tmpnewchar = tmpnewchar + "千"; break;
                  case 4: tmpnewchar = tmpnewchar + "万"; break;
                  case 5: if (perchar != 0) tmpnewchar = tmpnewchar + "十"; break;
                  case 6: if (perchar != 0) tmpnewchar = tmpnewchar + "百"; break;
                  case 7: if (perchar != 0) tmpnewchar = tmpnewchar + "千"; break;
                  case 8: tmpnewchar = tmpnewchar + "亿"; break;
                  case 9: tmpnewchar = tmpnewchar + "十"; break;
              }
              newchar = tmpnewchar + newchar;
          }   
          //替换所有无用汉字，直到没有此类无用的数字为止
          while (newchar.search("零零") != -1 || newchar.search("零亿") != -1 || newchar.search("亿万") != -1 || newchar.search("零万") != -1) {
              newchar = newchar.replace("零亿", "亿");
              newchar = newchar.replace("亿万", "亿");
              newchar = newchar.replace("零万", "万");
              newchar = newchar.replace("零零", "零");      
          }
          //替换以“一十”开头的，为“十”
          if (newchar.indexOf("一十") == 0) {
              newchar = newchar.substr(1);
          }
          //替换以“零”结尾的，为“”
          if (newchar.lastIndexOf("零") == newchar.length - 1) {
              newchar = newchar.substr(0, newchar.length - 1);
          }
          return newchar;
      },
      changeText(item){
        if(item.explanation){
          item.explanation = item.explanation.replace(/\n/g,"<br/>")
          let arr = item.explanation.split('⭐');
          if(arr.length >1){
            let str = '';
            arr.forEach((element,index)=>{
              if(index == 0){
                str +=  element;
              }else if(index == 1){
                str += '⭐' + element;
              }else{
                str += '</br>⭐' + element;
              }
            })
            return str
          }else{
            return item.explanation
          }
          
        }else if(item.repairation){
          item.repairation = item.repairation.replace(/\n/g,"<br/>")
          let arr = item.repairation.split('⭐');
          if(arr.length >1){
            let str = '';
            arr.forEach((element,index)=>{
              if(index == 0){
                str +=  element;
              }else if(index == 1){
                str += '⭐' + element;
              }else{
                str += '</br>⭐' + element;
              }
            })
            return str
          }else{
            console.log('aaa',JSON.stringify(item.repairation))
            return item.repairation
          }
          
        }else if(item.prevenience){
          item.prevenience = item.prevenience.replace(/\n/g,"<br/>")
          let arr = item.prevenience.split('⭐');
          if(arr.length >1){
            let str = '';
            arr.forEach((element,index)=>{
              if(index == 0){
                str +=  element;
              }else if(index == 1){
                str += '⭐' + element;
              }else{
                str += '</br>⭐' + element;
              }
            })
            return str
          }else{
            return item.prevenience
          }
         
        }else if(item.diagnosis){
          let arr = item.diagnosis.split('⭐');
          if(arr.length >1){
            let str = '';
            arr.forEach((element,index)=>{
              if(index == 0){
                str +=  element;
              }else if(index == 1){
                str += '⭐' + element;
              }else{
                str += '</br>⭐' + element;
              }
            })
            return str
          }else{
                      return item.diagnosis
          }

        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .nouser{
    color:#c3c3c3!important;
    .dian{
      background: #c3c3c3!important;
    }

  }
  .actived{
    height: auto!important;
    .sanjiao{
      transform: rotate(180deg);
      top:0px;
    }
  }
  .sanjiao{
    display: block;
    width: 0;
    height: 0;
    border-width: 12px;
    border-style: solid;
    border-color:  #000  transparent transparent transparent;
    position: relative;
    top:12px;
  }
  .zhengzhuang_title{
    text-align: center;
    margin-top: 40px;
    color:#333333;
    font-size: 28px;
    font-weight:500;
  }
  .title{
    color:#333333;
    font-weight:500;
    font-size: 28px;
    display: flex!important;
    justify-content: space-between;
 
    div{
      width: auto!important;
    }
    .dian{
      width: 12px;
      height: 12px;
      border-radius:50%;
      background: #333333; 
      display: inline-block;
      margin-right: 12px;
      position: relative;
      top:-5px;
    }
  }
  .diagnosis-container{
    margin-top:40px;
    .border-bottom{
      border-bottom: 2px solid #eee;
    }
    &>div{
      display: flex;
      justify-content: center;
      &.info{
        padding: 0 30px 30px 50px;
        padding-left:0;
        padding-right:0;
        margin-left: 30px;
        margin-right:30px;
      }
    }
    .tips{
      line-height: 32px!important;
      padding-bottom: 30px;
      border-bottom: 2px solid #eee;
    }
    .down{
      i{
        width: 22px;
        height: 14px;
        background: url("/images/public/arrow-down.png") no-repeat center;
        background-size: cover;
        display: block;
        margin-left: 4px;
      }
    }
    .up{
      i{
        width: 22px;
        height: 14px;
        background: url("/images/public/arrow-up.png") no-repeat center;
        background-size: cover;
        display: block;
        margin-left: 4px;
      }
    }
    .basic{
      display: flex;
      flex-wrap: wrap;
      div{
        width: 50%;
        line-height: 40px;
        margin-bottom: 20px;
        &:last-child, &:nth-last-child(2){
          margin-bottom: 0
        }
      }
    }
    .service{
      flex-direction: column;
      div{
        color: #FF6710;
        line-height: 40px;
        margin-bottom: 20px;
        &:last-child{
          margin: 0;
        }
      }
    }
    .diagnosis{
      display: block;
      border-bottom: 2px solid #eee;
      margin-top: 30px;
      height: 35px;
      overflow: hidden;
      div{
        display: block;
        width: 100%;
        line-height: 40px;
        margin-bottom: 20px;
        .diagnosis-photo{
          padding-bottom: 30px;
          display: flex;
          align-items: center;
          flex-direction: column;
          .compar-photo{
            display: flex;
            height: 252px;
            flex-wrap: wrap;
            justify-content: space-between;
            overflow: hidden;
            transition: all 0.3s linear;
            &.all{
              height: auto;
            }
            img{
              width: 316px;
              height: 248px;
              object-fit: cover;
              border-radius:6px;
              border:2px solid rgba(222,222,222,1);
              margin-bottom: 20px;
            }
          }
          button{
            padding: 0 20px;
            height:56px;
            border-radius:28px;
            border:2px solid rgba(214,214,214,1);
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .about{
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          button{
            padding: 0 20px;
            height:56px;
            border-radius:28px;
            border:2px solid rgba(214,214,214,1);
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .about-photo{
            width: 100%;
            height: 318px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            overflow: hidden;
            &>div{
              width: 314px;
              height: 314px;
              border: 1px solid #eee;
              border-radius: 12px;
              img{
                width: 100%;
                height: 234px;
                object-fit: cover;
              }
              div{
                text-align: center;
                height: 80px;
                line-height: 80px;
              }
            }
          }
        }
      }
    }
  }
</style>
